// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class QuoteProductDiscount {
  readonly id: string;
  readonly importedDiscountId: string;
  readonly name: string;
  readonly amountType: string;
  readonly appliedAmount: string;
  readonly stackable: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.importedDiscountId =
      data.importedDiscountId === undefined ? NIL_UUID : data.importedDiscountId;
    this.name = data.name === undefined ? '' : data.name;
    this.amountType = data.amountType === undefined ? '' : data.amountType;
    this.appliedAmount = data.appliedAmount === undefined ? '0' : data.appliedAmount;
    this.stackable = data.stackable === undefined ? false : data.stackable;
  }

  static zero(): QuoteProductDiscount {
    const zeroValues: ExcludeMethodsDeep<QuoteProductDiscount> = {
      id: NIL_UUID,
      importedDiscountId: NIL_UUID,
      name: '',
      amountType: '',
      appliedAmount: '0',
      stackable: false,
    };
    return new QuoteProductDiscount(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteProductDiscountWireFormat = {
  id: string;
  importedDiscountId: string;
  name: string;
  amountType: string;
  appliedAmount: string;
  stackable: boolean;
};

type NewQuoteProductDiscountProps = PartialDeep<QuoteProductDiscount, { recurseIntoArrays: true }>;
export const NewQuoteProductDiscount: (
  props: NewQuoteProductDiscountProps,
) => QuoteProductDiscount = (props) => new QuoteProductDiscount(props);

type NewQuoteProductDiscountFromWireFormatProps = PartialDeep<
  QuoteProductDiscountWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteProductDiscountFromWireFormat: (
  props: NewQuoteProductDiscountFromWireFormatProps,
) => QuoteProductDiscount = (props) => new QuoteProductDiscount(props);
